import script from "./form-collection.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-collection.vue?vue&type=script&setup=true&lang=ts"

import "./form-collection.vue?vue&type=style&index=0&id=11052922&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11052922"]])

export default __exports__